export class AudioPlayer {
  private readonly audioList: Record<string, HTMLAudioElement> = {
    beep: new Audio("/sfx/call-beep-long.mp3"),
    ring: new Audio("/sfx/call-ring-long.mp3"),
  };

  public constructor() {
    this.init = this.init.bind(this);
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    window.addEventListener("click", this.init);
  }

  private init() {
    window.removeEventListener("click", this.init);

    for (let key in this.audioList) {
      if (this.audioList[key]) {
        this.audioList[key].play();
        this.audioList[key].pause();
        this.audioList[key].currentTime = 0;
      }
    }
  }

  private startAudio(key: string) {
    if (this.audioList[key]) {
      this.audioList[key].currentTime = 0;
      this.audioList[key].play();
    }
  }

  public play(key: string, options: { loop?: boolean } = {}) {
    const { loop = false } = options;
    if (typeof this.audioList[key].loop === "boolean") {
      this.audioList[key].loop = loop;
    } else if (loop) {
      this.audioList[key].addEventListener("ended", () => this.startAudio(key));
    } else {
      this.audioList[key].removeEventListener("ended", () => this.startAudio(key));
    }
    this.startAudio(key);
  }

  public stop(key: string) {
    if (this.audioList[key]) {
      this.audioList[key].pause();
      this.audioList[key].currentTime = 0;
    }
  }
}

export default new AudioPlayer();
